import { type BusEvacuatieStatus } from "@/entities/betrokken-treinen";
import { useId } from "react";

function Clock() {
    return (
        <path
            d="M17 10C20.8587 10 24 13.1413 24 17C24 20.8587 20.8587 24 17 24C13.1413 24 10 20.8587 10 17C10 13.1413 13.1413 10 17 10ZM17 12.5547C16.5187 12.5547 16.125 12.9484 16.125 13.4297V17.3672L18.1641 19.4062C18.339 19.5723 18.5578 19.6602 18.7852 19.6602C19.0125 19.6601 19.2313 19.5811 19.4062 19.4062C19.7475 19.065 19.7475 18.5131 19.4062 18.1719L17.875 16.6406V13.4297C17.875 12.9484 17.4812 12.5547 17 12.5547Z"
            className="text-content-info"
            fill="currentColor"
        />
    );
}

function YellowClock() {
    return (
        <path
            d="M17 10C20.8587 10 24 13.1413 24 17C24 20.8587 20.8587 24 17 24C13.1413 24 10 20.8587 10 17C10 13.1413 13.1413 10 17 10ZM17 12.5547C16.5187 12.5547 16.125 12.9484 16.125 13.4297V17.3672L18.1641 19.4062C18.339 19.5723 18.5578 19.6602 18.7852 19.6602C19.0125 19.6601 19.2313 19.5811 19.4062 19.4062C19.7475 19.065 19.7475 18.5131 19.4062 18.1719L17.875 16.6406V13.4297C17.875 12.9484 17.4812 12.5547 17 12.5547Z"
            className="text-chart-yellow"
            fill="currentColor"
        />
    );
}

function Check() {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 17C10 13.13 13.13 10 17 10C20.87 10 24 13.13 24 17C24 20.87 20.87 24 17 24C13.13 24 10 20.87 10 17ZM16.13 20.2L20.55 15.39H20.56C20.84 15.08 20.82 14.61 20.51 14.33C20.2 14.05 19.73 14.07 19.45 14.38L16.09 18.04L14.53 16.48C14.24 16.19 13.76 16.19 13.47 16.48C13.18 16.77 13.18 17.25 13.47 17.54L16.13 20.2Z"
            className="text-content-success"
            fill="currentColor"
        />
    );
}

function Minus() {
    return (
        <path
            d="M17 10C20.8598 10.0001 23.9999 13.1402 24 17C24 20.8599 20.8599 23.9999 17 24C13.14 24 10 20.86 10 17C10.0001 13.1401 13.1401 10 17 10ZM13.5 16C13.2239 16 13 16.2239 13 16.5V17.5C13 17.7761 13.2239 18 13.5 18H20.5C20.7761 18 21 17.7761 21 17.5V16.5C21 16.2239 20.7761 16 20.5 16H13.5Z"
            className="text-chart-neutral"
            fill="currentColor"
        />
    );
}

function Doors() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 20C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0H2C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H18ZM14 1C13.4477 1 13 1.44772 13 2V18C13 18.5523 13.4477 19 14 19H18C18.5523 19 19 18.5523 19 18V11H17C16.4477 11 16 10.5523 16 10V4C16 3.44772 16.4477 3 17 3H19V2C19 1.44772 18.5523 1 18 1H14ZM12.2676 19C12.0974 18.7058 12 18.3643 12 18V2C12 1.63571 12.0974 1.29417 12.2676 1H7.73244C7.90261 1.29417 8 1.63571 8 2V18C8 18.3643 7.90261 18.7058 7.73244 19H12.2676ZM1 2C1 1.44772 1.44772 1 2 1H6C6.55228 1 7 1.44772 7 2V18C7 18.5523 6.55228 19 6 19H2C1.96548 19 1.93137 18.9983 1.89776 18.9948C1.3935 18.9436 1 18.5178 1 18V11H3C3.55228 11 4 10.5523 4 10V4C4 3.44772 3.55228 3 3 3H1V2ZM19 4V10H17V4H19ZM1 4V10H3V4H1Z"
                className="text-content-emphasis"
                fill="currentColor"
            />
        </svg>
    );
}

type BusEvacuatieStatusProps = {
    variant: BusEvacuatieStatus;
};

export function BusEvacuatieStatus({ variant }: BusEvacuatieStatusProps) {
    const maskId = useId();

    if (variant === "Aanvraag") {
        return <Doors />;
    }

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <path d="M24 0H0V24H9V12L12 9H24V0Z" fill="currentColor" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20 22C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20ZM16 3C15.4477 3 15 3.44772 15 4V20C15 20.5523 15.4477 21 16 21H20C20.5523 21 21 20.5523 21 20V13H19C18.4477 13 18 12.5523 18 12V6C18 5.44772 18.4477 5 19 5H21V4C21 3.44772 20.5523 3 20 3H16ZM14.2676 21C14.0974 20.7058 14 20.3643 14 20V4C14 3.63571 14.0974 3.29417 14.2676 3H9.73244C9.90261 3.29417 10 3.63571 10 4V20C10 20.3643 9.90261 20.7058 9.73244 21H14.2676ZM3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4V20C9 20.5523 8.55228 21 8 21H4C3.96548 21 3.93137 20.9983 3.89776 20.9948C3.3935 20.9436 3 20.5178 3 20V13H5C5.55228 13 6 12.5523 6 12V6C6 5.44772 5.55228 5 5 5H3V4ZM21 6V12H19V6H21ZM3 6V12H5V6H3Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
            </g>
            {variant === "Gedeeltelijk" && <Clock />}
            {variant === "AnnuleringAangevraagd" && <YellowClock />}
            {variant === "Volledig" && <Check />}
            {(variant === "Afgerond" || variant === "Geannuleerd") && <Minus />}
        </svg>
    );
}
